export default __webpack_public_path__ + "static/media/img_dealing.00eaf0bc.png";